<template>
  <Icon :icon="path" :data-icon="path" />
</template>

<script setup lang="ts">
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
})

const icons = getIcons()
const basePath = 'function-icons'
const startingWithNumber = /^\d/.test(props.icon)
const prefix = startingWithNumber ? '_' : ''
const iconName = prefix + props.icon.toLocaleLowerCase()
const iconPath = icons.includes(iconName) ? iconName : 'default'
const joinPath = (...paths: string[]) => {
  return paths.map((p) => p.replace(/^\/|\/$/, '')).join('/')
}
const path = joinPath(basePath, iconPath)

function getIcons() {
  return [
    'default',
    '_2-wege-reissverschluss',
    '_2-wege-stretch',
    '_3-in-1',
    '_4-wege-stretch',
    '_100prozent-alpaka',
    '_100prozent-baumwolle',
    '_100prozent-kaschmir',
    '_100prozent-merino',
    '_100prozent-wolle',
    'allwettertauglich',
    'atmungsaktiv',
    'bei-leichter-inkontinenz',
    'bei-mittlerer-inkontinenz',
    'bei-starker-inkontinenz',
    'buegelfrei',
    'buegellos',
    'classic-form_carla',
    'comfort-form-anna',
    'details-online',
    'doppelpack',
    'doppelverschluss',
    'echtleder',
    'empfehlenswert-bei-langem-sitzen',
    'federleicht',
    'feuchtigkeitsregulierend',
    'formbestaendig',
    'fuer-jede-jahreszeit',
    'fussspitze-handkettelt',
    'gefuetterte-pads',
    'herausnehmbare-pads',
    'kapuze-abtrennbar',
    'komfort-traeger-breite-traeger',
    'krempelbar',
    'leicht-waermend',
    'mehrfachpack',
    'minimizer',
    'mit-alpaka',
    'mit-baumwolle',
    'mit-biobaumwolle',
    'mit-buegel',
    'mit-kaschmir',
    'mit-merino',
    'mit-recyceltem-rohstoff',
    'mit-schurwolle',
    'mit-wolle',
    'modal',
    'nachhaltig',
    'nahtlos',
    'nicht-sichtbar',
    'pflegeleicht',
    'reflektierend',
    'rundum-dehnbund-louisa',
    'rundum-dehnbund',
    'schnelltrocknend',
    'shaping',
    'soft-touch',
    'stark-waermend',
    'stuetzend-und-durchblutungsfoerdernd',
    'teil-dehnbund-martha',
    'thermo',
    'trocknergeeignet',
    'twinset',
    'uv-schutz',
    'verdeckter-reissverschluss',
    'verstaerkte-bauchpartie',
    'verstellbare-traeger',
    'viskose',
    'vorderverschluss',
    'waermend',
    'waermeregulierend',
    'waschmaschinengeeignet',
    'wasser-abweisend',
    'wendejacke',
    'windabweisend',
    'zusaetzliche-taschen',
    'zweiteiler-v1',
    'zweiteiler-v2',
    'good-cashmere-2',
    'good-cashmere-premium-1',
  ]
}
</script>
